import React from "react";
var __jsx = React.createElement;
import bindable from '@monofe/ui-workspace/download-language/bind';
import { injectDownloadLanguage } from '@monofe/ui-workspace/download-language/interface';
import { injectKVStorage } from '@monofe/util';
import { useEffect } from 'react';
import { injectTourDataResolver } from '../utils/tourDataResolver.if';
const SHOW_DELAY_MS = 3000;

const _StorageKey = tour => "AutoTriggered-Download-".concat(tour.topBar.title.text);

const _canTriggerPopUp = (downloadLanguage, tour) => Promise.resolve(Boolean(downloadLanguage === null || downloadLanguage === void 0 ? void 0 : downloadLanguage.isShowable()) && tour.topBar.title.text.length > 0);

const _hasShownPopUp = tour => injectKVStorage().getBoolean(_StorageKey(tour));

const _setHasShownPopUp = tour => injectKVStorage().setItem(_StorageKey(tour), true);

function DownloadLanguageAlertTrigger(tour) {
  useEffect(() => {
    const updateState = async () => {
      bindable.setBuildDependencies({
        resolver: injectTourDataResolver()
      });
      const downloadLanguage = injectDownloadLanguage();
      const canShow = await _canTriggerPopUp(downloadLanguage, tour);
      const hasShown = await _hasShownPopUp(tour);

      if (canShow && !hasShown) {
        await _setHasShownPopUp(tour);
        downloadLanguage.show();
      }
    };

    setTimeout(() => {
      updateState().catch(error => {
        throw error;
      });
    }, SHOW_DELAY_MS);
  }, [tour]);
  return __jsx(React.Fragment, null);
}

export default DownloadLanguageAlertTrigger;